<template>
  <section>
    <tourism-news-list :query="query" />
  </section>
</template>

<script>
import TourismNewsList from '@/components/company/TourismNewsList'

export default {
  name: 'TourismNews',
  components: {
    TourismNewsList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
